import beFeed from 'actions/activity/beFeed.action';
import {
  aTypeMarkActivityFeedItemAsNotSeen,
  aTypeMarkActivityFeedItemAsNotUseful,
  aTypeMarkActivityFeedItemAsSeen,
  aTypeMarkActivityFeedItemAsSeenAtMutu,
  aTypeMarkActivityFeedItemAsUseful,
  aTypeMutuCallNumber,
  aTypeUpdateActivityFeed,
} from 'actions/shared.types';
import getObject from 'utils/accessors/getObject.util';
import asArray from 'utils/arrays/asArray.util';

import { APPOINTMENT_FAILURE, APPOINTMENT_REQUEST, APPOINTMENT_SUCCESS } from 'checkout/constants';

const IS_IN_FEED = window.location.href.indexOf('feed') < 0; // FIXME: reducer should not care about the window URL

// counting new items / can be removed if the server sends this info
const countUnseen = (items) => asArray(items).reduce((count, item) => (item.seen ? count : count + 1), 0);

const initState = () => ({
  feedData: [],
  isFetching: false,
  newItems: 0,
  hiddenItems: false,
  phoneCall: {
    isFetching: false,
    success: false,
    phone: '',
  },
  nextUrl: '',
  errorMessage: '',
  appId: -1,
});

const activityFeedReducer = (state = initState(), action) => {
  if (!action || !action.type) return state;

  const { isFetching, phoneCall: pc, feedData: stateFeedData } = state ?? {};
  const { type, params, errorMessage, response, event, data: actionData } = action ?? {};
  const { id, phone } = params ?? {};

  // response     is version 1 - old version
  // action?.json is version 3 - new version
  const { next, item, results } = (action?.json || response) ?? {};

  if (type === beFeed.AT.init) return { ...state, isFetching: true };
  if (type === beFeed.AT.done) return { ...state, isFetching: false };
  if (type === beFeed.AT.fail) return { ...state, errorMessage };

  if (type === beFeed.AT.pass) {
    const feedData = asArray(results);
    const newItems = countUnseen(feedData);
    return { ...state, isFetching: false, feedData, nextUrl: next, errorMessage: '', newItems };
  }

  if (type === aTypeUpdateActivityFeed.name) {
    if (isFetching) return state; // if we are fetching at the moment there is no point in updating

    const activity = { ...getObject('data.data', actionData), type: event };
    const feedData = [...stateFeedData];
    const foundIndex = feedData.findIndex((o) => o.id === activity.id);

    if (foundIndex === -1) {
      feedData.unshift(activity);
    } else {
      feedData.splice(foundIndex, 1, activity);
    }

    return { ...state, feedData, newItems: countUnseen(feedData) };
  }

  if (type === aTypeMarkActivityFeedItemAsUseful.name) {
    const feedData = stateFeedData.map((o) => (o.id === item.id ? { ...o, useful: true } : o));
    return { ...state, feedData };
  }

  if (type === aTypeMarkActivityFeedItemAsNotUseful.name) {
    const feedData = stateFeedData.map((o) => (o.id === id ? { ...o, useful: false } : o));
    return { ...state, feedData };
  }

  if (type === aTypeMarkActivityFeedItemAsSeenAtMutu.name || type === aTypeMarkActivityFeedItemAsSeen.name) {
    const feedData = stateFeedData.map((o) => (o.id === item.id ? { ...o, seen: true } : o));
    return { ...state, feedData, newItems: countUnseen(feedData) };
  }

  if (type === aTypeMarkActivityFeedItemAsNotSeen.name) {
    const feedData = stateFeedData.map((o) => (o.id === id ? { ...o, seen: false } : o));
    return { ...state, feedData, newItems: countUnseen(feedData) };
  }

  if (type === aTypeMutuCallNumber.init) {
    return { ...state, phoneCall: { ...pc, phone, isFetching: true, success: false } };
  }
  if (type === aTypeMutuCallNumber.pass) return { ...state, phoneCall: { ...pc, isFetching: false, success: true } };
  if (type === aTypeMutuCallNumber.fail) return { ...state, phoneCall: { ...pc, isFetching: false, success: false } };

  // TODO: (re)move logic that is not meant for activity feed from here and use it for error messages in other places
  if (type === APPOINTMENT_SUCCESS) return IS_IN_FEED ? { ...state } : { ...state, feedData: [...stateFeedData] };
  if (type === APPOINTMENT_FAILURE) return IS_IN_FEED ? { ...state } : { ...state, errorMessage };
  if (type === APPOINTMENT_REQUEST) return IS_IN_FEED ? { ...state } : { ...state, appId: id };

  return state;
};

export default activityFeedReducer;
